import { render, staticRenderFns } from "./email-template.vue?vue&type=template&id=c9bbfc16"
import script from "./email-template.vue?vue&type=script&lang=js"
export * from "./email-template.vue?vue&type=script&lang=js"
import style0 from "./email-template.vue?vue&type=style&index=0&id=c9bbfc16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports